import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {LocalizationProvider} from "@mui/x-date-pickers";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import React, {FC, useState} from "react";
import {TextField as MuiTextField} from "@material-ui/core";
import styled from "styled-components/macro";
import dayjs from "dayjs";

const TextField = styled(MuiTextField)`
  .MuiButtonBase-root {
    color: #bebebe
  }
`

type PropsType = {
  id?: string,
  name?: string,
  label: string,
  value: any,
  fullWidth?: boolean,
  onChange: (value: any) => void,
  format?: string,
  error?: boolean,
  helperText?: string | boolean
}

const DateField: FC<PropsType> = ({
  id = '',
  name = '',
  label,
  value,
  fullWidth = false,
  onChange,
  format = 'YYYY-MM-DD',
  error,
  helperText
}) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
    >
      <DatePicker
        label={label}
        value={dayjs(value)}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
        onChange={(d: any) => {
          onChange(dayjs(d).format(format))
        }}
        inputFormat={format}
        renderInput={(params) => (
          <TextField
            id={id}
            name={name}
            label={label}
            InputProps={{
              endAdornment: params.InputProps?.endAdornment,
              autoComplete: params.InputProps?.autoComplete,
              autoFocus: params.InputProps?.autoFocus,
              defaultValue: params.InputProps?.defaultValue,
              disabled: params.InputProps?.disabled,
              inputProps: params.inputProps,
              inputRef: params.inputRef,
              name: params.name,
              onBlur: params.onBlur,
              onChange: params.onChange,
              onFocus: params.onFocus,
              placeholder: params.placeholder,
              required: params.required,
              type: params.type,
              value: params.value
            }}
            error={error}
            helperText={helperText}
            variant={'outlined'}
            fullWidth={fullWidth}
          />
        )}
      />
    </LocalizationProvider>
  )
}

export default DateField